// extracted by mini-css-extract-plugin
module.exports = {"payment":"DisbursementSchedule_payment__3Khk9"};